module.exports = __webpack_public_path__ + "static/img/guide_9_1_1.7770b64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_9_1_1.jpg
// module id = pvyO
// module chunks = 1